module.exports = __webpack_public_path__ + "static/media/myAccountIcon.26438f5a.svg";